"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const index_1 = require("./enhancers/index");
/**
 * Expands aliases like `margin` to `marginTop`, `marginBottom`, `marginLeft` and `marginRight`.
 *
 * This prevents edge cases where longhand properties can't override shorthand
 * properties due to the style insertion order.
 */
function expandAliases(props) {
    const propNames = Object.keys(props);
    // Use a Map because it's faster for setting values and looping over than an Object
    const newProps = new Map();
    propNames.forEach(propName => {
        const propValue = props[propName];
        const aliases = index_1.propAliases[propName] || [propName];
        // Check that the alias has a valid value in development
        if (process.env.NODE_ENV !== 'production') {
            const validator = index_1.propValidators[propName];
            if (validator) {
                const result = validator(propValue);
                if (result) {
                    throw new Error(`📦 ui-box: ${result}`);
                }
            }
        }
        // Expand aliases
        aliases.forEach(alias => {
            newProps.set(alias, propValue);
        });
    });
    return newProps;
}
exports.default = expandAliases;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZXhwYW5kLWFsaWFzZXMuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi9zcmMvZXhwYW5kLWFsaWFzZXMudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7QUFBQSw2Q0FBNkQ7QUFHN0Q7Ozs7O0dBS0c7QUFDSCxTQUF3QixhQUFhLENBQUMsS0FBc0M7SUFDMUUsTUFBTSxTQUFTLEdBQUcsTUFBTSxDQUFDLElBQUksQ0FBQyxLQUFLLENBQUMsQ0FBQTtJQUNwQyxtRkFBbUY7SUFDbkYsTUFBTSxRQUFRLEdBQUcsSUFBSSxHQUFHLEVBQXdCLENBQUE7SUFFaEQsU0FBUyxDQUFDLE9BQU8sQ0FBQyxRQUFRLENBQUMsRUFBRTtRQUMzQixNQUFNLFNBQVMsR0FBaUIsS0FBSyxDQUFDLFFBQVEsQ0FBQyxDQUFBO1FBQy9DLE1BQU0sT0FBTyxHQUFhLG1CQUFXLENBQUMsUUFBUSxDQUFDLElBQUksQ0FBQyxRQUFRLENBQUMsQ0FBQTtRQUU3RCx3REFBd0Q7UUFDeEQsSUFBSSxPQUFPLENBQUMsR0FBRyxDQUFDLFFBQVEsS0FBSyxZQUFZLEVBQUU7WUFDekMsTUFBTSxTQUFTLEdBQUcsc0JBQWMsQ0FBQyxRQUFRLENBQUMsQ0FBQTtZQUMxQyxJQUFJLFNBQVMsRUFBRTtnQkFDYixNQUFNLE1BQU0sR0FBRyxTQUFTLENBQUMsU0FBUyxDQUFDLENBQUE7Z0JBQ25DLElBQUksTUFBTSxFQUFFO29CQUNWLE1BQU0sSUFBSSxLQUFLLENBQUMsY0FBYyxNQUFNLEVBQUUsQ0FBQyxDQUFBO2lCQUN4QzthQUNGO1NBQ0Y7UUFFRCxpQkFBaUI7UUFDakIsT0FBTyxDQUFDLE9BQU8sQ0FBQyxLQUFLLENBQUMsRUFBRTtZQUN0QixRQUFRLENBQUMsR0FBRyxDQUFDLEtBQUssRUFBRSxTQUFTLENBQUMsQ0FBQTtRQUNoQyxDQUFDLENBQUMsQ0FBQTtJQUNKLENBQUMsQ0FBQyxDQUFBO0lBRUYsT0FBTyxRQUFRLENBQUE7QUFDakIsQ0FBQztBQTNCRCxnQ0EyQkMifQ==